import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import ScheduledDeliveries from '../ScheduledDeliveriesContainer'
import DeliveryContainer from '../delivery/DeliveryContainer'

class ScheduledDeliveriesRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/drivers/delivery/:scheduledDeliveryId" render={() => <DeliveryContainer />} />
        <Route path="/drivers" render={() => <ScheduledDeliveries />} />
      </Switch>
    )
  }
}

export default ScheduledDeliveriesRoutes



// WEBPACK FOOTER //
// ./src/containers/drivers/routes/routes.js